/* TAREXO Landingpage: Galerie, Bundle-Auswahl, Warenkorb, Jetzt kaufen */
(() => {
  const T = window.TAREXO || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  let qty = 1;

  // Geldformat aus den Shop-Einstellungen (z. B. "{{amount_with_comma_separator}} €")
  function money(cents) {
    const fmt = T.moneyFormat || '{{amount_with_comma_separator}} €';
    const n = (cents / 100);
    const de = n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const en = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_with_comma_separator') return de;
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(n).toLocaleString('de-DE');
      if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      return en;
    }).replace(/<[^>]*>/g, '');
  }
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  // Galerie
  $$('.thumbs button').forEach(b => b.addEventListener('click', () => {
    $$('.thumbs button').forEach(x => x.setAttribute('aria-pressed', 'false'));
    b.setAttribute('aria-pressed', 'true');
    const img = $('#mainImg');
    if (img) { img.removeAttribute('srcset'); img.src = b.dataset.src; }
  }));

  // Bundle-Auswahl (Fallback-Klasse für Browser ohne :has())
  const bundles = $('#bundles');
  function syncBundles() {
    $$('.bundle', bundles).forEach(l => l.classList.toggle('on', l.querySelector('input').checked));
    const on = $('input[name="bundle"]:checked', bundles);
    if (!on) return;
    qty = parseInt(on.value, 10) || 1;
    const lbl = $('#ctaLabel');
    if (lbl && T.variantId) lbl.textContent = `In den Warenkorb · ${on.dataset.price}`;
  }
  if (bundles) { bundles.addEventListener('change', syncBundles); syncBundles(); }

  // Warenkorb-API
  async function getCart() { return (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); }
  async function setQty(q) {
    const cart = await getCart();
    const line = cart.items.find(i => i.variant_id === T.variantId);
    const res = line
      ? await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: q }) })
      : await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: T.variantId, quantity: q }] }) });
    if (!res.ok) {
      let msg = 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
      try { const e = await res.json(); if (e.description) msg = e.description; } catch (_) {}
      throw new Error(msg);
    }
  }
  function showErr(msg) {
    const e = $('#cartErr');
    if (e) { e.textContent = msg; e.hidden = false; } else { alert(msg); }
  }

  // Drawer
  const drawer = $('#drawer'), scrim = $('#scrim');
  const open = () => { drawer.hidden = false; scrim.hidden = false; document.body.style.overflow = 'hidden'; };
  const close = () => { drawer.hidden = true; scrim.hidden = true; document.body.style.overflow = ''; };
  scrim.addEventListener('click', close);
  $('#closeCart').addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hidden) close(); });

  async function renderCart() {
    const cart = await getCart();
    $('#cartCount').textContent = cart.item_count;
    const body = $('#drawerBody'), foot = $('#drawerFoot');
    if (!cart.item_count) {
      body.innerHTML = '<p style="color:var(--mute)">Dein Warenkorb ist leer.</p>';
      foot.innerHTML = T.variantId ? '<button class="cta" style="margin:0" type="button" data-add="1">Set hinzufügen</button>' : `<a class="cta" style="margin:0;text-decoration:none" href="${esc(T.productUrl)}">Zum Produkt</a>`;
      return;
    }
    const line = cart.items.find(i => i.variant_id === T.variantId);
    const ship = cart.total_price >= 10000 ? 0 : 499;
    const up = line && line.quantity === 1 && T.upsell
      ? `<div class="upsell"><span><b>Zweites Set für den Kollegen?</b><br>Im 2er-Pack sparst du, und der Versand ist kostenlos.</span><button type="button" data-set="2">+ Hinzufügen</button></div>` : '';
    body.innerHTML = cart.items.map(i => `
      <div class="line"><img src="${esc(i.image || T.productImage)}" alt=""><div><b>${esc(i.product_title)}</b>
        <div class="qty"><button type="button" aria-label="weniger" data-key="${esc(i.key)}" data-q="${i.quantity - 1}">−</button><span>${i.quantity}</span><button type="button" aria-label="mehr" data-key="${esc(i.key)}" data-q="${i.quantity + 1}">+</button></div></div>
        <b>${money(i.final_line_price)}</b></div>`).join('') + up + `
      <div class="sum">
        ${cart.total_discount > 0 ? `<div><span>Mengenrabatt</span><span class="y">−${money(cart.total_discount)}</span></div>` : ''}
        <div><span>Versand</span>${ship ? `<span>${money(ship)}</span>` : '<span class="y">kostenlos</span>'}</div>
        <div class="tot"><span>Gesamt</span><span>${money(cart.total_price + ship)}</span></div>
        ${ship ? '<div class="note"><span>Ab 2 Sets versandkostenfrei</span></div>' : ''}
        <div class="note"><span>inkl. MwSt.</span></div></div>`;
    foot.innerHTML = '<a class="cta" style="margin:0;text-decoration:none" href="/checkout">Zur Kasse</a><div class="cta-sub" style="margin-top:10px"><span>Sicher bezahlen</span><span>Ab 2 Sets versandkostenfrei</span></div>';
  }
  $('#drawerBody').addEventListener('click', async e => {
    const b = e.target.closest('button'); if (!b) return;
    b.disabled = true;
    try {
      if (b.dataset.key) {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.key, quantity: Math.max(0, +b.dataset.q) }) });
      } else if (b.dataset.set) { await setQty(+b.dataset.set); }
      await renderCart();
    } catch (err) { showErr(err.message); await renderCart(); }
  });
  $('#drawerFoot').addEventListener('click', async e => {
    const b = e.target.closest('[data-add]'); if (!b) return;
    try { await setQty(1); await renderCart(); } catch (err) { showErr(err.message); }
  });
  $('#openCart').addEventListener('click', async () => { await renderCart(); open(); });

  // In den Warenkorb (Hero und weitere CTAs)
  async function addAndOpen(btn) {
    if (!T.variantId) { location.href = T.productUrl; return; }
    btn && (btn.disabled = true);
    try { await setQty(qty); await renderCart(); open(); }
    catch (err) { showErr(err.message); }
    finally { btn && (btn.disabled = false); }
  }
  const hero = $('#heroCta');
  if (hero) hero.addEventListener('click', () => addAndOpen(hero));
  $$('[data-cta]').forEach(b => b.addEventListener('click', () => addAndOpen(b)));

  // Jetzt kaufen: Menge übernehmen und direkt zur Kasse
  const buy = $('#fcta');
  buy.addEventListener('click', async () => {
    if (!T.variantId) {
      const cart = await getCart();
      location.href = cart.item_count ? '/checkout' : T.productUrl;
      return;
    }
    buy.disabled = true;
    try { await setQty(qty); location.href = '/checkout'; }
    catch (err) { buy.disabled = false; showErr(err.message); }
  });
})();
